// extracted by mini-css-extract-plugin
export default {"wrapper":"tea","container":"uea","title":"vea","desc":"wea","usage":"xea","box":"yea","subtitle":"zea","ingredients":"Aea","carousel":"Bea","ingredientscarousel":"Cea","productinfo":"Eea","ingredientsinfo":"Fea"};
    if(module.hot) {
      // 1743628931625
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  